import React from "react";

import ReusableAdd from "../ReusableAdd";

function Add() {
  return <ReusableAdd></ReusableAdd>;
}

export default Add;
